var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green-checkmark_svg__clip0_128_677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20.212L6.038 15l-1.775 1.762 6.987 6.988 15-15-1.762-1.763L11.25 20.212z",
    fill: "#399A7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "green-checkmark_svg__clip0_128_677"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyOF82NzcpIj4KPHBhdGggZD0iTTExLjI1IDIwLjIxMjVMNi4wMzc1MSAxNUw0LjI2MjUxIDE2Ljc2MjVMMTEuMjUgMjMuNzVMMjYuMjUgOC43NDk5OUwyNC40ODc1IDYuOTg3NDlMMTEuMjUgMjAuMjEyNVoiIGZpbGw9IiMzOTlBN0MiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMjhfNjc3Ij4KPHJlY3Qgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgGreenCheckmark as ReactComponent };